import styled from 'styled-components';
export const UnitName = styled.div``;
